import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// New Firebase project configuration (mylocalgov2)
const firebaseConfig = {
  apiKey: "AIzaSyA8-c5SN78eGvFhDIRf1npg7sDu8g7EyKk",
  authDomain: "mylocalgov2.firebaseapp.com",
  projectId: "mylocalgov2",
  storageBucket: "mylocalgov2.firebasestorage.app",
  messagingSenderId: "217367615078",
  appId: "1:217367615078:web:5963b071f991e734a1bfa7",
  measurementId: "G-YY1X048QPC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firebase Storage
export const storage = getStorage(app);

// Initialize Analytics (optional)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Initialize Firebase Cloud Messaging
let messaging = null;
if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
  } catch (e) {
    console.log('FCM not supported in this browser:', e);
  }
}

export const VAPID_KEY = 'BBtZUbjc1en20nMPo0YbSIxIEIoSki-Td19IEl6btzSwZtlx9_NC4mqyybcC4b0B6JkdYP2w6sWO5wNJ8Uvh6cc';

export const requestNotificationPermission = async () => {
  if (!messaging) {
    console.log('FCM messaging not initialized');
    return null;
  }
  
  try {
    const permission = await Notification.requestPermission();
    console.log('Notification permission:', permission);
    
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }
    
    // Register unified service worker for FCM + caching
    let registration;
    try {
      registration = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
      await navigator.serviceWorker.ready;
      console.log('Service worker registered for FCM');
    } catch (swError) {
      console.error('Service worker registration failed:', swError);
      return null;
    }
    
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });
    
    if (token) {
      console.log('FCM Token obtained:', token.substring(0, 30) + '...');
    } else {
      console.log('No FCM token returned');
    }
    
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

// Force refresh token (call this on every app load for logged-in users)
export const refreshFCMToken = async () => {
  if (!messaging) return null;
  if (Notification.permission !== 'granted') return null;
  
  try {
    let registration = await navigator.serviceWorker.getRegistration('/');
    if (!registration) {
      registration = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
      await navigator.serviceWorker.ready;
    }
    
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });
    
    return token;
  } catch (error) {
    console.error('Error refreshing FCM token:', error);
    return null;
  }
};

export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
};

export { analytics, messaging };
export default app;
